import React, { useEffect, useState } from "react";
import { createApiClient, useApiClient } from "../../components/useApiClient";
import { useUser } from '../../components/UserContext';
import { Alert, Tooltip, Select, MenuItem } from '@mui/material';
import { PortfolioDto } from "../../models/Portfolio";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import { DashboardFilterState } from "../../models/Dashboard";
import './DashboardStyleSheet.css';

interface DashboardFiltersProps {
    value: DashboardFilterState;
    onChange: (next: DashboardFilterState) => void;
}

export const DashboardFilters: React.FC<DashboardFiltersProps> = ({
    value,
    onChange,
}) => {
    const { get } = useApiClient();
    const { activeClientId, getAccessToken } = useUser();

    const [portfolios, setPortfolios] = useState<PortfolioDto[]>([]);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            try {

                const accessToken = await getAccessToken();

                if (accessToken) {

                    const portfolios = await get<PortfolioDto[]>(`portfolios`, accessToken);
                    setPortfolios(portfolios);

                    
                }

            } catch (err: any) {
                console.info("Get portfolios error", err);
            }
        };

        void load();

    }, [activeClientId]);

    const handleChange = (patch: Partial<DashboardFilterState>) => {
        onChange({ ...value, ...patch });
    };

    return (
        <div className="dashboard-filters">
            <Select
                value={value.portfolioId}
                onChange={(e) => handleChange({ portfolioId: e.target.value })}
            >
                <MenuItem value="all" sx={{ fontSize: "0.85rem", py: 0.5 }}>Full Collection</MenuItem>
                {portfolios.map((p) => (
                    <MenuItem key={p.portfolioId} value={p.portfolioId} sx={{ fontSize: "0.85rem", py: 0.5 }}>
                        {p.name}
                    </MenuItem>
                ))}
            </Select>

            <Select
                value={value.valuationType}
                onChange={(e) =>
                    handleChange({
                        valuationType: e.target.value as DashboardFilterState["valuationType"],
                    })
                }
            >
                <MenuItem value="acquisition" sx={{ fontSize: "0.85rem", py: 0.5 }}>Acquisition</MenuItem>
                <MenuItem value="market value" sx={{ fontSize: "0.85rem", py: 0.5 }}>Market value</MenuItem>
                <MenuItem value="insurance" sx={{ fontSize: "0.85rem", py: 0.5 }}>Insurance</MenuItem>
            </Select>
            <DatePicker
                label="As of Date"
                value={value.asOfDate ? dayjs(value.asOfDate) : null}
                onChange={(e) => handleChange({ asOfDate: e?.toISOString() })}
            />
        </div>
    );
};
